import React from "react";
import ReactDOM from "react-dom/client";

import App from "./App";
import { applyTheme, getStoredTheme } from "@/lib/theme";
import "./index.css";

applyTheme(getStoredTheme());

const rootEl = document.getElementById("root");
if (!rootEl) throw new Error("#root not found");

ReactDOM.createRoot(rootEl).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
